import { IBloggerUrl } from 'entities/Source';

export const getBloggerUrls = (bloggerUrls: Record<string, string[]>, platformTypes: string[]) => {
	const urls: IBloggerUrl[] = [];

	Object.keys(bloggerUrls).forEach((type) => {
		platformTypes.includes(type) &&
			bloggerUrls[type].forEach((url) => {
				url &&
					urls.push({
						platform_type: type,
						url,
					});
			});
	});

	return urls;
};
